const dev = {
  SITE_URL: 'https://hrservice.olegb.ru',
  API_URL: 'https://hrservice.olegb.ru/api/v1/',
  WEBSOCKET_URL: 'wss://hrservice.olegb.ru/ws',
};

export { dev as default };
